import { createElement } from 'react';
import { ElementFactory, Serializer } from 'survey-core';
import { PropertyGridEditorCollection } from 'survey-creator-core';
import { ReactQuestionFactory } from 'survey-react-ui';
import { QuestionEditorModel, SurveyEditorWidget } from './components/CustomEditorWidget';
import { registerButton } from './components/buttonModel';
import { registerJSONEditor } from './components/jsonModel';
import { PageBreak } from './components/pagebreak';
import { registerRubricGrid } from './components/rubricModel';

export function registerCustomWidgets() {
  // Register the model in `ElementFactory`
  ElementFactory.Instance.registerElement('editor', (name) => {
    return new QuestionEditorModel(name);
  });

  Serializer.addClass('pagebreak', [], () => new PageBreak(''), 'question');

  Serializer.addClass(
    'editor',
    [{ name: 'height', default: '200px', category: 'layout' }],
    () => new QuestionEditorModel(''),
    'question'
  );

  // Register `SurveyQuestionEditor` as a class that renders `editor` questions
  ReactQuestionFactory.Instance.registerQuestion('editor', (props) => {
    return createElement(SurveyEditorWidget, props);
  });

  // Register `editor` as an editor for properties of the `text` and `html` types in the Survey Creator's Property Grid
  PropertyGridEditorCollection.register({
    fit: function (prop) {
      return (
        (prop.type == 'text' || prop.type == 'html') && ['title', 'description'].includes(prop.name)
      );
    },
    getJSON: function () {
      return { type: 'editor' };
    }
  });

  /*CustomWidgetCollection.Instance.addCustomWidget(
    NuiSliderWidget(),
    'customtype'
  );*/
  // extended question types
  registerRubricGrid();
  registerJSONEditor();
  registerButton();
}
